/**
 * Loss categories offered by the intake form's "Loss Type" select.
 *
 * One vocabulary for both clients (IOS-201): GamutIOS offers the same six.
 * Pinned against the server's matcher vocabulary
 * (GamutServer pkg/models/loss_category.go) by lossCategories.test.ts.
 * "Other" intentionally matches no server category family.
 */
export const LOSS_CATEGORIES = ['Water', 'Fire', 'Mold', 'Storm', 'Biohazard', 'Other'] as const;

export type LossCategory = (typeof LOSS_CATEGORIES)[number];

/**
 * True when the stored value is non-blank and not one of the offered
 * categories (a legacy, iOS-typed, or server-written free-text value such as
 * "Fire/Smoke"). The select must still display and keep it.
 */
export function isUnlistedLossCategory(value: string | undefined | null): boolean {
    const v = (value ?? '').trim();
    return v !== '' && !(LOSS_CATEGORIES as readonly string[]).includes(value as string);
}
